import { adCopyTypes } from '@functions/adCopy'
import { stringHasContent } from '@functions/utility'

import useAdCopies from '@hooks/useAdCopies'

type AdCopyReviewerParams = {
  campaignId: number,
  sharedAdCopyTypes: string[],
}

const useAdCopyReviewer = (params: AdCopyReviewerParams) => {
  const { campaignId, sharedAdCopyTypes } = params

  const adCopiesPayload = useAdCopies({
    filters: { campaign_id: campaignId },
  })
  const { filteredAdCopies, loading } = adCopiesPayload

  const filteredAdCopiesWithContent = filteredAdCopies?.filter(
    item => ((stringHasContent(item?.description)) || stringHasContent(item?.tagline))
      && sharedAdCopyTypes?.includes(item?.copy_type),
  )

  // standardise the order in which the ad copies are listed.
  // this keeps them in the same order as displayed everywhere else in realhub.
  const displayAdCopyTypes = adCopyTypes.filter(adCopyType => (
    filteredAdCopiesWithContent?.some(adCopy => adCopy.copy_type === adCopyType.key)
  ))

  const hasSharedAdCopyTypes = sharedAdCopyTypes?.length > 0

  return {
    displayAdCopyTypes,
    filteredAdCopiesWithContent,
    hasSharedAdCopyTypes,
    loading,
  }
}

export default useAdCopyReviewer
